exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pull-left,\n.selected-item-item {\n  border: 1px solid black; }\n\n::ng-deep .department-tree .selected-container-text {\n  height: 35px;\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-left: 5px; }\n\n::ng-deep .department-tree .selected-item-text {\n  padding-top: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/department-tree-2/department-tree-2.component.scss
// module id = ../../../../../src/app/_custom/department-tree-2/department-tree-2.component.scss
// module chunks = main